function ExperiencesPanel() {
  return (
    <div className="full-height align-center">
      <div className="p-3 grey-3 index-card-background-top">
        <img
          src={process.env.PUBLIC_URL + "/images/home/collections.png"}
          className="index-card-icon"
          alt="cameraIcon"
        />
        <div className="index-card-header">Experiences</div>
        <div className="left">
          While most of my life is built on refining, I do enjoy collecting experiences like visiting states, exploring niche muesums, and hiking national parks.
        </div>
      </div>
      <div className="p3 grey-2 index-card-background-bottom">
        <a href="./collections" className="index-card-see-more no-line">
          <div className="index-card-see-more no-line">SEE MORE</div>
        </a>
      </div>

    </div>
  );
}

export default ExperiencesPanel;
